import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type BlockState = 'none' | 'soft' | 'hard';

interface SessionGuardState {
  blockState: BlockState;
  idleWarningOpen: boolean;
  lastActivityAt: number;
  actions: {
    recordActivity: () => void;
    showIdleWarning: () => void;
    dismissIdleWarning: () => void;
    escalate: (to: 'soft' | 'hard') => void;
    reset: () => void;
  };
}

export const useSessionGuardStore = create<SessionGuardState>()(
  devtools(
    subscribeWithSelector(
      immer((set, _get) => ({
        blockState: 'none',
        idleWarningOpen: false,
        lastActivityAt: Date.now(),
        actions: {
          recordActivity: () =>
            set((s) => {
              s.lastActivityAt = Date.now();
              if (s.idleWarningOpen) s.idleWarningOpen = false;
            }),
          showIdleWarning: () =>
            set((s) => {
              s.idleWarningOpen = true;
            }),
          dismissIdleWarning: () =>
            set((s) => {
              s.idleWarningOpen = false;
              s.lastActivityAt = Date.now();
            }),
          escalate: (to) =>
            set((s) => {
              s.blockState = to;
            }),
          reset: () =>
            set((s) => {
              s.blockState = 'none';
            }),
        },
      })),
    ),
    { name: 'SessionGuardStore' },
  ),
);
